module.exports = __webpack_public_path__ + "img/new_founder_header.c266ebb3.png";